<script>
  export let item;
</script>


<a href={item.link} class="text-xl text-gray-900 text-opacity-60 font-medium hover:text-opacity-95">
  <slot></slot>
</a>